var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgFacebook = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3B5998",
    d: "M12.65 0C19.636 0 25.3 5.664 25.3 12.65c0 6.986-5.664 12.65-12.65 12.65C5.664 25.3 0 19.636 0 12.65 0 5.664 5.664 0 12.65 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.274 5.36v2.618h-1.6c-1.252 0-1.487.585-1.487 1.428v1.874h2.985l-.398 2.935h-2.587v7.526h-3.116v-7.526H7.474V11.28h2.597V9.118c0-2.508 1.578-3.877 3.88-3.877 1.1 0 2.048.08 2.323.12z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFacebook, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/facebook.1343e21c.svg";
export { ForwardRef as ReactComponent };